import Dialog from "../../../../dialog/dialog.index";
import { handleSetResources, handleSetVersioningModalStatus, handleSetVersionResources } from "../../../fileManager.actions";
import Button from "../../../../button/button.index";
import { ButtonType } from "../../../../button/button.interface";
import { useEffect, useState } from "react";
import { advancedResponseValidator, get } from "../../../../../../scripts/api";
import API from "../../../../../../urls/api";
import Loader from "../../../../loader/loader.index";
import { ResourceType } from "../../../../../../interfaces/general";
import VersioningCard from "./versioningCard/versioningCard.index";
import { ENVIRONMENT } from "../../../../../../environment";
import { useAppSelector } from "../../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function VersioningModal({ fileInput }: any): JSX.Element {
    const { selectedResources, versioningModalStatus, versionResources, resources } = useAppSelector(
        ({ fileManager: { selectedResources, versioningModalStatus, versionResources, resources } }) => ({
            selectedResources,
            versioningModalStatus,
            versionResources,
            resources
        }),
        shallowEqual
    );
    const [versionGroup, setVersionGroup] = useState("");

    useEffect(() => {
        if (selectedResources[0] && versioningModalStatus) {
            setVersionGroup(selectedResources[0].version_group!);
            getVersionResources();
        }
    }, [selectedResources, versioningModalStatus]);

    const getVersionResources = () => {
        get((data, status) => {
            if (advancedResponseValidator(data, status)) {
                handleSetVersionResources(data);
            }
        }, API.fileManager.versionHistory(selectedResources[0].version_group!));
    };

    const handleBrowseFile = () => {
        fileInput.current.click();
    };

    const handleCloseModal = () => {
        handleSetVersionResources(undefined);
        handleSetVersioningModalStatus(false);
        if (versionResources) {
            const currentVersion = versionResources!.find((item: ResourceType) => item.is_current_version);
            handleSetResources(
                resources!.map((item: ResourceType) => {
                    if (item.version_group === versionGroup) {
                        return currentVersion!;
                    } else {
                        return item;
                    }
                })
            );
        }
    };

    const handleDelete = () => {
        getVersionResources();
    };

    return (
        <Dialog title="مدیریت نسخه ها" status={versioningModalStatus} onClose={handleCloseModal}>
            {selectedResources[0] && (
                <div className="p-4 pt-0 flex flex-col">
                    <div>
                        <p className="text-[14px] !text-secondary-600 mb-4 text-justify">
                            نسخه‌های قدیمی‌تر «{selectedResources[0].name}» ممکن است پس از ۳۰ روز یا پس از ذخیره ۱۰۰ نسخه حذف شوند. برای جلوگیری از
                            حذف، منوی زمینه را در نسخه فایل باز کنید و “ <b>نگه‌داری برای همیشه</b> ” را انتخاب کنید. نسخه‌ها به ترتیبی که در{" "}
                            {ENVIRONMENT.brandName} آپلود شده‌اند نمایش داده می‌شوند
                        </p>
                        <Button
                            autoFocus={false}
                            text="آپلود نسخه‌ی جدید"
                            type={ButtonType.SECONDARY}
                            className="max-w-[300px] w-full mx-auto"
                            onClick={handleBrowseFile}
                            disable={versionResources ? versionResources.length > 100 : false}
                        />
                    </div>
                    <div className="mt-8 flex-1 overflow-y-auto overflow-hidden">
                        {versionResources ? (
                            versionResources.length > 0 ? (
                                versionResources.map((item: ResourceType) => <VersioningCard key={item.id} resource={item} onDelete={handleDelete} />)
                            ) : (
                                "no items"
                            )
                        ) : (
                            <Loader />
                        )}
                    </div>
                </div>
            )}
        </Dialog>
    );
}
